import { useQuery } from "react-query";

import { G1Country } from "doxecure-commons/doxecureLocales";
import { CorporationIdentifiersDictionary } from "doxecure-commons/doxecureTypes";
import { $count, $ok } from "foundation-ts/commons";
import { TSCountry } from "foundation-ts/tscountry";
import { country } from "foundation-ts/types";

import { AvailableCorporationIdentifiersID } from "@hooks/hooksConstants";
import apiClient from "@services/apiClient";

const useAvailableCorporationIdentifiers = (countries?: G1Country[]) =>  useQuery(
    [AvailableCorporationIdentifiersID, countries],
    async () => {
        const map: Map<country, CorporationIdentifiersDictionary> = new Map() ;
        if ($ok(countries)) { 
            for (let g1Country of countries!) {
                const country = TSCountry.country(g1Country.code)!.alpha2Code ;
                const [corporationIdentifiersDict, _status] = await apiClient.getAvailableCorporationIdentifiers(country) ;
                if ($ok(corporationIdentifiersDict)) {
                    map.set(country, corporationIdentifiersDict!) ;
                }
            }
        }
        return map ;
    },
    {
        enabled: $count(countries) > 0
    }
) ;

export default useAvailableCorporationIdentifiers ;